import Breadcrumbs from '@storeblocks/breadcrumbs';
import { type FC } from 'react';

import { useOrganizationCmId } from '@/api/userSettings/hooks/useOrganizationCmId';
import { AnnouncementWarning } from '@/components/AnnouncementWarning';
import { CenteredPageContent } from '@/components/CenteredPageContent';
import { InternalLink } from '@/components/InternalLink';
import { PageHeading } from '@/components/PageHeading';
import { useTexts } from '@/hooks/useTexts';

import { CopyBearerToken } from './CopyBearerToken';
import { ThrowError } from './ThrowError';

export const DebugPage: FC = () => {
  const texts = useTexts();
  const organizationCmId = useOrganizationCmId();
  const rootPath = organizationCmId ? `/${organizationCmId}` : '/';

  return (
    <CenteredPageContent data-test="debug-page">
      <AnnouncementWarning />

      <Breadcrumbs expandAllAriaLabel={texts.breadcrumbs.expandAllAriaLabel}>
        <InternalLink to={rootPath}>{texts.menu.links.home}</InternalLink>
        <InternalLink to={`${rootPath}/debug`}>Debug</InternalLink>
      </Breadcrumbs>

      <PageHeading header="Debug" />

      <CopyBearerToken />

      <ThrowError />
    </CenteredPageContent>
  );
};
